import { render, staticRenderFns } from "./ContactLensesMetaDropdown.vue?vue&type=template&id=c8064f90&scoped=true"
import script from "./ContactLensesMetaDropdown.vue?vue&type=script&lang=js"
export * from "./ContactLensesMetaDropdown.vue?vue&type=script&lang=js"
import style0 from "./ContactLensesMetaDropdown.vue?vue&type=style&index=0&id=c8064f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8064f90",
  null
  
)

export default component.exports